import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=cb0a5950&scoped=true"
import script from "./OrderPayment.vue?vue&type=script&lang=js"
export * from "./OrderPayment.vue?vue&type=script&lang=js"
import style0 from "./OrderPayment.vue?vue&type=style&index=0&id=cb0a5950&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a5950",
  null
  
)

export default component.exports